"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CVS_ICON = exports.LOGISTICS_SUBTYPE_DISPLAY = exports.LOGISTICS_TYPE = exports.LOGISTICS_SUBTYPE = exports.LOGISTICS_TYPE_DISPLAY = exports.PAYMENT_SUBTYPE = exports.PAYMENT_SUBTYPE_DISPLAY = exports.onUseCoupon = exports.onSelectCVS = exports.getAddressSetByZip = exports.getDistricts = exports.getCities = exports.checkoutRequest = exports.editConfig = exports.removeFromCart = exports.addToCart = exports.calcPrice = exports.fetchCart = void 0;
var Config_1 = require("../Config");
var ApiUtil_1 = require("../Utils/ApiUtil");
function fetchCart() {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart?token=" + Config_1.get().UserOutlet.getValue().token)];
        case 1:
          nextCart = _a.sent();
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.fetchCart = fetchCart;
function calcPrice(productId, _a) {
  var qty = _a.qty,
    variants = _a.variants,
    _b = _a.extraConfigs,
    extraConfigs = _b === void 0 ? {} : _b;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/calc", {
            method: 'post',
            data: {
              product: productId,
              config: {
                qty: qty,
                variants: variants,
                extra_data: __assign({}, extraConfigs)
              }
            }
          })];
        case 1:
          return [2 /*return*/, _c.sent()];
      }
    });
  });
}
exports.calcPrice = calcPrice;
function addToCart(productId, _a) {
  var qty = _a.qty,
    variants = _a.variants,
    _b = _a.extraConfigs,
    extraConfigs = _b === void 0 ? {} : _b;
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/add?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: {
              product: productId,
              config: {
                qty: qty,
                variants: variants,
                extra_data: __assign({}, extraConfigs)
              }
            }
          })];
        case 1:
          nextCart = _c.sent();
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.addToCart = addToCart;
function removeFromCart(index) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/delete?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: {
              index: index
            }
          })];
        case 1:
          nextCart = _a.sent();
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.removeFromCart = removeFromCart;
function editConfig(nextConfig) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/edit_config?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: nextConfig
          })];
        case 1:
          nextCart = _a.sent();
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.editConfig = editConfig;
function onUseCoupon(coupon) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/coupon/use?token=" + Config_1.get().UserOutlet.getValue().token + "&client_id=" + Config_1.get().clientId, {
            method: 'post',
            data: {
              coupon: coupon
            }
          })];
        case 1:
          nextCart = _a.sent();
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.onUseCoupon = onUseCoupon;
function checkoutRequest(coupon) {
  return __awaiter(this, void 0, void 0, function () {
    var withCoupon, withoutCoupon;
    return __generator(this, function (_a) {
      withCoupon = Config_1.get().apiHost + "/checkout/request?token=" + Config_1.get().UserOutlet.getValue().token + "&coupon=" + encodeURIComponent(coupon);
      withoutCoupon = Config_1.get().apiHost + "/checkout/request?token=" + Config_1.get().UserOutlet.getValue().token;
      window.location.href = !!coupon ? withCoupon : withoutCoupon;
      return [2 /*return*/];
    });
  });
}

exports.checkoutRequest = checkoutRequest;
function getCities() {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req('https://daiwanlang.netlify.app/api/行政區/get', {
            method: 'GET'
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.getCities = getCities;
function getDistricts(city) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req("https://daiwanlang.netlify.app/api/\u884C\u653F\u5340/" + city + "/get", {
            method: 'GET'
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.getDistricts = getDistricts;
function getAddressSetByZip(zip) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req("https://daiwanlang.netlify.app/api/\u884C\u653F\u5340/\u90F5\u905E\u5340\u865F/" + zip + "/get", {
            method: 'GET'
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.getAddressSetByZip = getAddressSetByZip;
function onSelectCVS() {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      window.location.href = Config_1.get().apiHost + "/cart/cvs-map?client_id=" + Config_1.get().clientId + "&token=" + Config_1.get().UserOutlet.getValue().token;
      return [2 /*return*/];
    });
  });
}

exports.onSelectCVS = onSelectCVS;
var PAYMENT_SUBTYPE = {
  default: 'default',
  credit: 'credit',
  cod: 'cod'
};
exports.PAYMENT_SUBTYPE = PAYMENT_SUBTYPE;
var PAYMENT_SUBTYPE_DISPLAY = (_a = {}, _a[PAYMENT_SUBTYPE.default] = {
  label: '預設付款方式',
  value: PAYMENT_SUBTYPE.default
}, _a[PAYMENT_SUBTYPE.credit] = {
  label: '信用卡付款',
  value: PAYMENT_SUBTYPE.credit
}, _a[PAYMENT_SUBTYPE.cod] = {
  label: '貨到付款',
  value: PAYMENT_SUBTYPE.cod
}, _a);
exports.PAYMENT_SUBTYPE_DISPLAY = PAYMENT_SUBTYPE_DISPLAY;
var LOGISTICS_TYPE = {
  cvs: 'CVS',
  home: 'HOME'
};
exports.LOGISTICS_TYPE = LOGISTICS_TYPE;
var LOGISTICS_TYPE_DISPLAY = (_b = {}, _b[LOGISTICS_TYPE.cvs] = {
  label: '超商取貨',
  value: 'CVS'
}, _b[LOGISTICS_TYPE.home] = {
  label: '宅配到府',
  value: 'HOME'
}, _b);
exports.LOGISTICS_TYPE_DISPLAY = LOGISTICS_TYPE_DISPLAY;
var LOGISTICS_SUBTYPE = {
  famic2c: 'FAMIC2C',
  unimartc2c: 'UNIMARTC2C',
  hilifec2c: 'HILIFEC2C',
  TCAT: 'TCAT',
  ECAN: 'ECAN'
};
exports.LOGISTICS_SUBTYPE = LOGISTICS_SUBTYPE;
var LOGISTICS_SUBTYPE_DISPLAY = (_c = {}, _c[LOGISTICS_SUBTYPE.famic2c] = {
  label: '全家便利超商',
  value: LOGISTICS_SUBTYPE.famic2c
}, _c[LOGISTICS_SUBTYPE.unimartc2c] = {
  label: '統一便利超商',
  value: LOGISTICS_SUBTYPE.unimartc2c
}, _c[LOGISTICS_SUBTYPE.hilifec2c] = {
  label: '萊爾富便利超商',
  value: LOGISTICS_SUBTYPE.hilifec2c
}, _c[LOGISTICS_SUBTYPE.TCAT] = {
  label: '黑貓宅急便',
  value: LOGISTICS_SUBTYPE.TCAT
}, _c[LOGISTICS_SUBTYPE.ECAN] = {
  label: '宅配通',
  value: LOGISTICS_SUBTYPE.ECAN
}, _c);
exports.LOGISTICS_SUBTYPE_DISPLAY = LOGISTICS_SUBTYPE_DISPLAY;
var CVS_ICON = (_d = {}, _d[LOGISTICS_SUBTYPE.famic2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/fimi_logo-1631158279', _d[LOGISTICS_SUBTYPE.unimartc2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/unimart_logo-1631158301', _d[LOGISTICS_SUBTYPE.hilifec2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/hilife_logo-1631158173', _d);
exports.CVS_ICON = CVS_ICON;